import type { GetStaticPaths, GetStaticProps } from "next"
import {
  type AuthorArchiveProps,
  getAuthorArchive,
  getAuthorPagePaths,
} from "@/components/resources/data/archives"
import { isAuthorSlug } from "@/components/resources/data/markdown/authors"
import { SiteLayout } from "@/components/resources/layouts/site"
import { AuthorPage } from "@/components/resources/templates/AuthorPage"
import { parsePageParam } from "@/components/resources/utils/pagination"

const AuthorPosts = (props: AuthorArchiveProps) => <AuthorPage {...props} />

AuthorPosts.getLayout = SiteLayout

export default AuthorPosts

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: await getAuthorPagePaths(),
  fallback: false,
})

export const getStaticProps: GetStaticProps<
  AuthorArchiveProps,
  { slug: string; n: string }
> = async ({ params }) => {
  const slug = params?.slug
  const page = parsePageParam(params?.n)
  const props = slug && isAuthorSlug(slug) && page ? await getAuthorArchive(slug, page) : null
  return props ? { props, revalidate: 180 } : { notFound: true }
}
